import type { LiveEditingSnapshot } from "./boundary-draft-baseline.utils";

export function buildPreviewBoundaryDraftFeatureFromLive(
  live: LiveEditingSnapshot,
  existing: GeoJSON.Feature<GeoJSON.Polygon> | null,
  defaultDocumentId?: string,
): GeoJSON.Feature<GeoJSON.Polygon> {
  const { boundaryId, geometry, properties } = live;
  const props = properties;
  const existingProps = existing?.properties as Record<string, unknown> | undefined;
  const documentId =
    (props?.documentId as string | undefined) ??
    (existingProps?.documentId as string | undefined) ??
    defaultDocumentId ??
    "";

  return {
    type: "Feature",
    id: boundaryId,
    geometry,
    properties: {
      ...existingProps,
      ...props,
      id: boundaryId,
      previewId: boundaryId,
      documentId,
    },
  };
}

export function buildCustomLayerBoundaryDraftFeatureFromLive(
  live: LiveEditingSnapshot,
  existing: GeoJSON.Feature<GeoJSON.Polygon> | null,
  fallbackLayerId?: string,
): GeoJSON.Feature<GeoJSON.Polygon> | null {
  const { boundaryId, geometry, properties } = live;
  const props = properties;
  const existingProps = existing?.properties as Record<string, unknown> | undefined;
  const layerId =
    (props?.customLayerId as string | undefined) ??
    (existingProps?.customLayerId as string | undefined) ??
    fallbackLayerId ??
    "";

  if (!layerId) {
    return null;
  }

  return {
    type: "Feature",
    id: boundaryId,
    geometry,
    properties: {
      ...existingProps,
      ...props,
      id: boundaryId,
      customLayerId: layerId,
    },
  };
}

export function buildMapLevelBoundaryDraftFeatureFromLive(
  live: LiveEditingSnapshot,
  existing: GeoJSON.Feature<GeoJSON.Polygon> | null,
  fallbackMapLevelId?: string,
): GeoJSON.Feature<GeoJSON.Polygon> | null {
  const { boundaryId, geometry, properties } = live;
  const props = properties;
  const existingProps = existing?.properties as Record<string, unknown> | undefined;
  const mapLevelId =
    (props?.mapLevelId as string | undefined) ??
    (existingProps?.mapLevelId as string | undefined) ??
    fallbackMapLevelId ??
    "";

  if (!mapLevelId) {
    return null;
  }

  return {
    type: "Feature",
    id: boundaryId,
    geometry,
    properties: {
      ...existingProps,
      ...props,
      id: boundaryId,
      mapLevelId,
    },
  };
}
